"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createClientForEnvironment = void 0;
__exportStar(require("./HttpAdapter"), exports);
function createClientForEnvironment() {
    let adapter = undefined;
    if (typeof window !== 'undefined' && typeof window.fetch !== 'undefined') {
        // For browsers use XHR adapter
        adapter = require('./FetchAdapter').default; // eslint-disable-line
    }
    else if (typeof process !== 'undefined' &&
        Object.prototype.toString.call(process) === '[object process]') {
        // For node use HTTP adapter
        adapter = require('./NodeAdapter').default; // eslint-disable-line
    }
    if (!adapter) {
        throw new Error('Unable to determine HttpClient for environment');
    }
    return new adapter();
}
exports.createClientForEnvironment = createClientForEnvironment;
